export enum TypeToastEnum {
  INFO = "info",
  SUCCESS = "success",
  WARNING = "warning",
  DANGER = "danger",
  PERSISTENT = "persistent",
}
